import axios from "axios"
import RestApiService from "./RestApiService"
import UsuarioService from "./UsuarioService"

const controller = "/ordenCompra"

const OrdenCompraService = {
    async obtener(request) {
        return RestApiService.send(`${controller}/obtener`, request)
    },
    async buscar(request) {
        const { data } = await axios.post(`${controller}/buscar`, request)
        return data
    },
    async obtenerDetallexTransferencia(request) {
        const { data } = await axios.post(`${controller}/obtenerDetallexTransferencia`, request)
        return data
    },
    async generarReporte2(request) {
        const { data } = await axios.post(`${controller}/generarReporte2`, request)
        return data
    },
    async paginarxProveedor(request) {
        return RestApiService.send(`${controller}/paginarxProveedor`, request)
    },
    async paginarxProveedor(request) {
        return RestApiService.send(`${controller}/paginarxProveedor`, request)
    },
}

export default OrdenCompraService